import { IExcelRowDecorator } from "./iexcel-row-decorator";
import * as Excel from "exceljs";

export class ProductExportReadmeDecorator implements IExcelRowDecorator {
    private readonly _headerLabel: string;
    private readonly _subHeadersLabel: string[];
    private readonly _urgentLabel: string[];

    public constructor(headerLabel: string, subHeadersLabel: string[], urgentLabel: string[]) {
        this._headerLabel = headerLabel;
        this._subHeadersLabel = subHeadersLabel;
        this._urgentLabel = urgentLabel;
    }

    public decorate(row: Excel.Row) {
        if (row.worksheet.id === 1) {
            return;
        }

        if (row.number === 1) {
            row.worksheet.getColumn(1).width = 30;
            row.worksheet.getColumn(2).width = 45;
            row.worksheet.getColumn(3).width = 30;
        }

        row.eachCell(c => {
            const cellValue = c.value?.toString() ?? "";

            if (this._headerLabel === cellValue) {
                c.font = {
                    bold: true,
                    color: {
                        argb: "FFEC008C",
                    },
                };
            }

            if (this._urgentLabel.includes(cellValue)) {
                c.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: {
                        argb: "FFEDCDCD",
                    },
                };
            }

            if (this._subHeadersLabel.includes(cellValue)) {
                c.font = {
                    bold: true,
                };
            }
        });
    }

    public reset() {
        return;
    }
}
